import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSpareInvoices, SpareInvoice } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './spareInvoicesModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SpareInvoice> useData={useSpareInvoices} config={config} />;
};

export default List;
